// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"256":"07d8ccd3","382":"b7298a3a","475":"88473b17"}[chunkId] + ".chunk.css";
};